export const GET_PROJECT_STATUS_REQUEST = 'GET_PROJECT_STATUS_REQUEST';
export const GET_PROJECT_STATUS_SUCCESS = 'GET_PROJECT_STATUS_SUCCESS';
export const GET_PROJECT_STATUS_FAILURE = 'GET_PROJECT_STATUS_FAILURE';
